import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { pricing } from '../data/eatWellContent';
export function MidPageCta() {
  return <section className="w-full border-y border-champagne/25 bg-charcoal-950 py-12 sm:py-14" aria-labelledby="mid-cta-title" data-id="element-136" data-mp="3jlle6sc068m">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-137" data-mp="8hn8d2svoppd">
        <h2 id="mid-cta-title" className="font-display text-[1.5rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2rem]" data-id="element-138" data-mp="37xtmotmnorcb">
          You already know what tonight should taste like.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-139" data-mp="3gxgpnjv1a57h">
          This is the system that gets it on the table — 5 volumes, 75 recipes, 5
          bonuses, and your first 20-minute meal cooked today.
        </p>

        <p className="mt-6 text-[12px] uppercase tracking-[0.12em] text-muted" data-id="element-140" data-mp="117dkj6ay9hiu">
          <span className="line-through" data-id="element-141" data-mp="119giccicgey4">{pricing.regularPrice}</span>
          <span className="ml-3 font-semibold text-champagne" data-id="element-142" data-mp="1cf23iph1f377">
            Today {pricing.today} USD
          </span>
        </p>

        <div className="mt-5 flex justify-center" data-id="element-143" data-mp="18c5rjhm065c8">
          <CtaButton size="md" data-id="element-144" data-mp="13dujncf9q4wn" />
        </div>
        <TrustStrip className="mt-3" data-id="element-145" data-mp="13gqgsyjakpk1" />
      </div>
    </section>;
}